import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRelux = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 194",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "#000",
		d: "M928.8 92.2 998 11.5h-84.2l-34.1 48.1-33-48.1h-88.8l67.3 81.4-69.4 84.1h82.5l37.1-52.5 35.2 52.5h89.3l-71.1-84.8zm-53.4 23.7-39.8 54.8h-68l65.5-78.4-63.3-74.4H844l35.8 50.7 37.4-50.7H986l-64.4 74.5 66.1 78.3h-73.3l-39-54.8zM745.2 11.5h-64.7v99s1.7 30-26.2 30.8c-28.2.2-26.7-30.8-26.7-30.8l-.2-99h-65.9v105.6s-6.4 68.1 93.7 65.4c95.8.9 90-65.4 90-65.4V11.5zm-92.3 165.1c-95-1.6-85.2-58.7-85.2-58.7l-.6-100h54.5l.2 91.5s-1.1 37.8 31.3 37.9c35.9.2 33-37.9 33-37.9l.2-91.5h53.2l.1 100c-.1 0 5.1 60.3-86.7 58.7zm-178.4-44.2V11.5l-68.5-.1V177h137.5v-44.6h-69zm63.1 38.3H411.8V17.9h56.7v120.9l69.1.2v31.7zM222.8 12.1h147.6v34.6h-84.9V77h79.6v34.6h-79.6v30.3h85.8v34.6H222.8V12.1M0 12.1h125.6c45 0 64.4 18.7 67.1 52 2.3 29.1-9.4 43.4-25.4 49.4l28.7 62.9h-61.3l-25.3-59.7H64.9v59.7H0V12.1M64.9 85h42.4c13.9 0 25.8-4.2 24.5-20-1.2-14.6-9.8-19.6-25.6-19.6H64.9V85"
	})]
});
const ForwardRef = forwardRef(SvgRelux);
export default ForwardRef;
